import { gql, useMutation, useQuery } from '@apollo/client';
import React from 'react';
import Imgix from 'react-imgix';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import styled from 'styled-components';
import { GET_TOTAL_CART_PRODUCTS } from '../../../../../../common/SharedQueries';
import { SliderSlickStyles } from '../../../../../../common/SliderSlickStyles';
import LeftArrow from '../../../../../../common/svgs/LeftArrow';
import RightArrow from '../../../../../../common/svgs/RightArrow';
import {
  addProductLocalCart,
  deleteLocalCartItem
} from '../../../../../../store/actions';
import {
  formatGTMDataForAddToCart,
  gtmTrackEvent
} from '../../../../../../utils/gtmTrackEvent';
import { getImgixUrl, getName, getPrice } from '../../../../../../utils/helper';
import { GET_ALL_CART_PRODUCTS } from '../../../../cart/hooks/useCart';
import Item from './Item';

const Wrapper = styled.div`
  margin-top: 15px;
  padding: 0 40px 40px;

  .selection-slider-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: ${({ hasSelection }) => (hasSelection ? '430px' : 'auto')};
  }

  .your-selection {
    display: ${({ hasSelection }) => (hasSelection ? 'inline-block' : 'none')};
    width: 20%;
  }
  .slider-container {
    width: ${({ hasSelection }) => (hasSelection ? '65%' : '100%')};
    margin-top: ${({ hasSelection }) => (hasSelection ? '41px' : '0')};
    display: inline-block;
  }

  .slick-prev:before,
  .slick-next:before {
    display: none;
  }

  .slick-next {
    padding: 20px;
    right: -30px;
    top: 130px;
    svg {
      position: absolute;
      top: 0;
    }
  }

  .slick-track {
    display: flex;
    align-items: stretch;
    justify-content: center;
    .slick-slide {
      height: auto;
    }
    .slick-slide > div {
      height: 100%;
    }
    .slick-slide > div > div {
      height: 100%;
    }
  }

  .slick-prev {
    padding: 20px;
    top: 130px;
    left: -35px;
    z-index: 1;
    svg {
      position: absolute;
      top: 0;
    }
  }

  .slick-arrow {
    svg {
      width: 12px;
      path {
        stroke-width: 3px;
      }
    }
  }
  .slick-track {
    display: flex;

    .slick-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      height: auto;
    }
  }

  @media (max-width: 992px) {
    .your-selection {
      display: none;
    }
    .slider-container {
      width: 100%;
    }

    .slick-arrow {
      svg {
        width: 16px;
      }
    }

    .hide-mobile {
      display: none;
    }
    .slick-dots li.slick-active button:before {
      background: ${({ theme }) => theme.colors.limoncello};
      opacity: 1;
      border: none;
      font-size: 8px;
    }

    .slick-dots li button:before {
      background: #d9d9d9;
      font-family: 'Times New Roman', Times, serif;
      box-sizing: border-box;
      content: '' !important;
      height: 8px;
      left: 0px;
      opacity: 0.5;
      position: absolute;
      right: 0px;
      top: 0px;
      width: 8px;
      /* border: 1px solid rgb(0, 0, 0); */
      border-radius: 100% 100% 100% 100%;
      transition: all 0.2s ease 0s;
    }

    /* .grid {
      grid-template-columns: repeat(2, 1fr);
    } */
  }
`;

const CompleteTheLookItem = styled.div`
  padding: 20px;
  height: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .image-container {
    background: red;
    width: 200px;
    height: 200px;
    display: flex;
    margin-top: auto;
    margin-bottom: 20px;
    align-items: center;
    justify-content: center;
    /* img {
      height: ${props => (props.ratio == 1 ? '100%' : 'auto')};
      width: ${props => (props.ratio == 1 ? 'auto' : '100%')};
    } */
  }

  .name-fabric-price {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fabric-name {
    font-weight: 100;
    font-size: 14px;
    text-align: center;
    color: #737373;
    margin-bottom: 0px;
  }

  .name, .price, .your-selection-text {
    letter-spacing: 0.04em;
    font-family: "${({ theme }) => theme.fonts.primary}";
    font-size: 16px;
    text-align: center;
    color: ${({ theme }) => theme.colors.charcoal};
    opacity: 1;
  }

  .price {
    margin-bottom: 15px;
  }

  p, .your-selection-text {
    font-weight: bold;
    text-align: center;
    margin-bottom: 5px;
  }

  .name {
    line-height: 2em;
    font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  }

  img {
    cursor: pointer;
    width: 100%;
    height: auto;
  }
  button {
    width: 100%;
    height: 50px;
  }

  @media (max-width: 992px) {
    .image-container {
    width: 120px;
    height: auto;
    display: flex;
    margin-top: auto;
    margin-bottom: 40px;
    align-items: center;
    justify-content: center;
  }
  }
`;

export const Title = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-size: 32px;
  line-height: 40px;
  color: ${({ theme }) => theme.colors.charcoal};
  opacity: 0.9;
  margin-top: 0;
  margin-bottom: 20px;

  .step {
    color: ${({ theme }) => theme.colors.charcoal};
  }

  @media (max-width: 992px) {
    font-size: 30px;
  }
`;

function CompleteTheLook(props) {
  const [logError] = useMutation(LOG_ERROR);
  const history = useHistory();
  const { loading, error, data } = useQuery(COMPLETE_THE_LOOK, {
    variables: { sku: props.productSku, origin: props.origin },
    onCompleted(data) {
      if (props.onCompleted) {
        props.onCompleted(data);
      }
      if (!data) {
        logError({
          variables: {
            error: `Complete the look could not load ${
              props.cart ? 'in cart' : 'in pdp'
            }`
          }
        });
      }
    }
  });

  const [addToCart] = useMutation(CREATE_CART_PRODUCT, {
    onCompleted(data) {
      gtmTrackEvent(
        formatGTMDataForAddToCart(
          data.createCartProduct.product,
          data.createCartProduct.quantity
        )
      );
    },
    refetchQueries: () => [
      {
        query: GET_ALL_CART_PRODUCTS
      },
      {
        query: GET_TOTAL_CART_PRODUCTS
      }
    ]
  });

  if (loading) return '';
  if (error) return `Error! ${error}`;
  if (!data || !data.completeTheLook || !data.completeTheLook.length) {
    return '';
  }

  const settings = {
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 380,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  };

  const renderCompleteTheLook = () => {
    return (
      data &&
      data.completeTheLook.map(product => {
        const { name, slug, sku, images, fabric, price, id } = product;
        return (
          <div key={sku}>
            <Item
              setChangeFeaturedFabrics={props.setChangeFeaturedFabrics}
              name={name}
              slug={slug}
              sku={sku}
              size={product?.frame?.size?.name}
              images={images}
              fabric={fabric}
              price={price}
              id={id}
              product={product}
              cart={props.cart}
              source={props.source}
              isAuthenticated={props.isAuthenticated}
              addToCart={addToCart}
              onAddProductLocalCart={props.onAddProductLocalCart}
              history={history}
            />
          </div>
        );
      })
    );
  };

  const completeTheLookTitle = false
    ? 'Customers Also Bought'
    : 'Complete the Look';

  const getTitle = () => {
    if (props.title) {
      return props.title;
    }

    if (props.emptyTitle) {
      return '';
    }

    if (props.frameId == 79) {
      return 'Need a Frame?';
    }
    if ([175, 564, 78].includes(parseInt(props.frameId))) {
      return 'Change Up Your Look';
    }
    return completeTheLookTitle;
  };

  const title = getTitle();

  return (
    <SliderSlickStyles>
      <Wrapper hasSelection={props.hasSelection}>
        <div className="container">
          {title ? <Title>{title}</Title> : ''}
          <div className="selection-slider-container">
            <div className="your-selection">
              <div className="your-selection-title">
                {props.hasSelection && (
                  <CompleteTheLookItem style={{ paddingTop: 0 }}>
                    <div className="your-selection-text">Your Selection</div>
                    <div className="image-container">
                      <div className="image-container">
                        <Imgix
                          imgixParams={{ auto: 'compress,format' }}
                          sizes="(min-width: 993px) 200px,
                           120px"
                          src={getImgixUrl(props.productInfo.images[0]?.path)}
                          htmlAttributes={{
                            alt: 'your-selection'
                          }}
                        />
                      </div>
                    </div>
                    <div className="name-fabric-price">
                      <p className="name">{getName(props.productInfo.name)}</p>
                      <p className="price">
                        ${getPrice(props.productInfo.price)}
                      </p>
                      <p className="fabric-name">
                        {props.productInfo.fabric.name}
                        {props.productInfo.fabric.collaborator &&
                          ' by ' + props.productInfo.fabric.collaborator.name}
                      </p>
                    </div>
                  </CompleteTheLookItem>
                )}
              </div>
            </div>
            <div className="slider-container">
              <Slider {...settings}>{renderCompleteTheLook()}</Slider>
            </div>
          </div>
        </div>
      </Wrapper>
    </SliderSlickStyles>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
    localCart: state.LocalCart.localCart
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDeleteLocalCartItem: swatchId => {
      dispatch(deleteLocalCartItem(swatchId));
    },
    onAddProductLocalCart: (product, quantity, source) => {
      dispatch(addProductLocalCart(product, quantity, source));
    }
  };
};
const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default connecter(CompleteTheLook);

const COMPLETE_THE_LOOK = gql`
  query completeTheLook($sku: String, $origin: String) {
    completeTheLook(sku: $sku, origin: $origin) {
      id
      sku
      name
      price
      slug
      is_swatch
      images {
        id
        name
        path
        width
        height
      }
      fabric {
        id
        is_available_on_pdp
        name
        image
        collaborator {
          id
          name
        }
        material {
          id
          name
        }
      }
      leg {
        id
        name
      }
      frame {
        id
        name
        orientation
        size {
          id
          is_available_on_pdp
          name
        }
        subcategories {
          id
          category {
            id
            name
          }
        }
      }
    }
  }
`;

const SlickButtonFix = ({ currentSlide, slideCount, children, ...props }) => (
  <div className="arrow-container" {...props}>
    {children}
  </div>
);

const PrevArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <LeftArrow />
    </div>
  );
};

const NextArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <RightArrow />
    </div>
  );
};

const CREATE_CART_PRODUCT = gql`
  mutation createCartProduct(
    $product_id: ID!
    $quantity: Int!
    $type: String!
    $source: Int
  ) {
    createCartProduct(
      product_id: $product_id
      quantity: $quantity
      type: $type
      source: $source
    ) {
      id
      quantity
      product {
        id
        sku
        slug
        name
        price
        is_swatch
        fabric {
          id
          is_available_on_pdp
          name
          image
          collaborator {
            id
            name
          }
          material {
            id
            name
          }
        }
        leg {
          id
          name
        }
        frame {
          id
          name
          orientation
          size {
            id
            is_available_on_pdp
            name
          }
          subcategories {
            id
            category {
              id
              name
            }
          }
        }
        images {
          id
          path
        }
      }
    }
  }
`;

const NOTIFY_KLAVIYO = gql`
  mutation notifyKlaviyo($email: String!, $event: String!, $product_id: ID) {
    notifyKlaviyo(email: $email, event: $event, product_id: $product_id) {
      success
    }
  }
`;

const LOG_ERROR = gql`
  mutation logError($error: String!) {
    logError(error: $error) {
      success
    }
  }
`;
